import {
    ROOT,
    ACCOUNT_MANAGE_FUNCTION_GET_ALL,
    ACCOUNT_MANAGE_USER_GET_ALL,
    ACCOUNT_MANAGE_USER_DETAIL,
    ACCOUNT_MANAGE_USER_CREATE,
    ACCOUNT_MANAGE_USER_UPDATE,
    ACCOUNT_MANAGE_USER_DELETE,
    ACCOUNT_MANAGE_USER_GET_FUNCTION,
    ACCOUNT_MANAGE_USER_UPDATE_FUNCTION,
    ACCOUNT_MANAGE_USERGROUP_GET_ALL,
    ACCOUNT_MANAGE_USERGROUP_GET_ALL_ACTIVE,
    ACCOUNT_MANAGE_USERGROUP_DETAIL,
    ACCOUNT_MANAGE_USERGROUP_CREATE,
    ACCOUNT_MANAGE_USERGROUP_UPDATE,
    ACCOUNT_MANAGE_USERGROUP_DELETE,
    ACCOUNT_MANAGE_USERGROUP_GET_FUNCTION,
    ACCOUNT_MANAGE_USERGROUP_UPDATE_FUNCTION,
    GET_ALL_CHAIN_OF_USER,
    GET_ALL_HOTEL_OF_USER,
    GET_AREA_CODE
} from '@/_helpers/constant.js';
import { requestOptions, handleResponse } from '@/_helpers';

function getAllFunction() {
    return fetch(ROOT + ACCOUNT_MANAGE_FUNCTION_GET_ALL, requestOptions.get())
        .then(handleResponse);
}

function getAllUser(params) {
    return fetch(ROOT + ACCOUNT_MANAGE_USER_GET_ALL, requestOptions.post(params))
        .then(handleResponse);
}

function getUserDetail(username) {
    return fetch(ROOT + ACCOUNT_MANAGE_USER_DETAIL + `/` + username, requestOptions.get())
        .then(handleResponse);
}

function createUser(data) {
    return fetch(ROOT + ACCOUNT_MANAGE_USER_CREATE, requestOptions.post(data))
        .then(handleResponse);
}

function updateUser(data) {
    return fetch(ROOT + ACCOUNT_MANAGE_USER_UPDATE, requestOptions.post(data))
        .then(handleResponse);
}

function deleteUser(username) {
    return fetch(ROOT + ACCOUNT_MANAGE_USER_DELETE + `/` + username, requestOptions.get())
        .then(handleResponse);
}

function getUserFunction(username) {
    return fetch(ROOT + ACCOUNT_MANAGE_USER_GET_FUNCTION + `/` + username, requestOptions.get())
        .then(handleResponse);
}

function updateUserFunction(data) {
    return fetch(ROOT + ACCOUNT_MANAGE_USER_UPDATE_FUNCTION, requestOptions.post(data))
        .then(handleResponse);
}

function getAllUserGroup(params) {
    return fetch(ROOT + ACCOUNT_MANAGE_USERGROUP_GET_ALL, requestOptions.post(params))
        .then(handleResponse);
}

function getAllActiveUserGroup(params) {
    return fetch(ROOT + ACCOUNT_MANAGE_USERGROUP_GET_ALL_ACTIVE, requestOptions.post(params))
        .then(handleResponse);
}

function getUserGroupDetail(id) {
    return fetch(ROOT + ACCOUNT_MANAGE_USERGROUP_DETAIL + `/` + id, requestOptions.get())
        .then(handleResponse);
}

function createUserGroup(data) {
    return fetch(ROOT + ACCOUNT_MANAGE_USERGROUP_CREATE, requestOptions.post(data))
        .then(handleResponse);
}

function updateUserGroup(data) {
    return fetch(ROOT + ACCOUNT_MANAGE_USERGROUP_UPDATE, requestOptions.post(data))
        .then(handleResponse);
}

function deleteUserGroup(id) {
    return fetch(ROOT + ACCOUNT_MANAGE_USERGROUP_DELETE + `/` + id, requestOptions.get())
        .then(handleResponse);
}

function getUserGroupFunction(id) {
    return fetch(ROOT + ACCOUNT_MANAGE_USERGROUP_GET_FUNCTION + `/` + id, requestOptions.get())
        .then(handleResponse);
}

function updateUserGroupFunction(data) {
    return fetch(ROOT + ACCOUNT_MANAGE_USERGROUP_UPDATE_FUNCTION, requestOptions.post(data))
        .then(handleResponse);
}

function getAllChains() {
    return fetch(ROOT + GET_ALL_CHAIN_OF_USER, requestOptions.get())
        .then(handleResponse);
}

function getAllHotels() {
    return fetch(ROOT + GET_ALL_HOTEL_OF_USER, requestOptions.get())
        .then(handleResponse);
}

function getAreaCode() {
    return fetch(ROOT + GET_AREA_CODE, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
}

export const service = {
    getAllFunction,
    getAllUser,
    getUserDetail,
    createUser,
    updateUser,
    deleteUser,
    getUserFunction,
    updateUserFunction,
    getAllUserGroup,
    getAllActiveUserGroup,
    getUserGroupDetail,
    createUserGroup,
    updateUserGroup,
    deleteUserGroup,
    getUserGroupFunction,
    updateUserGroupFunction,
    getAllChains,
    getAllHotels,
    getAreaCode
};